var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 0C100.289 0 0 35.816 0 80V432C0 476.182 100.289 512 224 512S448 476.182 448 432V80C448 35.816 347.711 0 224 0ZM432 325.682C407.273 347.686 326.463 368 224 368S40.727 347.686 16 325.682V184.539C56.129 210.217 141.539 224 224 224S391.871 210.217 432 184.539V325.682ZM224 16C350.973 16 432 53.904 432 80V165.682C407.273 187.686 326.463 208 224 208S40.727 187.686 16 165.682V80C16 53.904 97.027 16 224 16ZM224 496C97.027 496 16 458.096 16 432V344.539C56.129 370.217 141.539 384 224 384S391.871 370.217 432 344.539V432C432 458.096 350.973 496 224 496Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.e629f73596187273bc073e93c69fff1b.svg";
export { ForwardRef as ReactComponent };